import { render, staticRenderFns } from "./SindhMap.vue?vue&type=template&id=651f1341&scoped=true&"
import script from "./SindhMap.vue?vue&type=script&lang=js&"
export * from "./SindhMap.vue?vue&type=script&lang=js&"
import style0 from "./SindhMap.vue?vue&type=style&index=0&id=651f1341&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f1341",
  null
  
)

export default component.exports